import {
  Accordion,
  Box,
  Grid,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";

import React from "react";
import { connect, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import SearchByCompanyID from "./searchInputs/SearchByCompanyID";
import AutoCompleteCompanyAndEvent from "./searchInputs/AutocompleteSearch";
import DatesInput from "./searchInputs/DatesInput";
import ReplayIcon from "@mui/icons-material/Replay";
import {
  getEventByCompanyID,
  getEventByKeyStroke,
  getStatByID,
} from "../redux/action/stats";

const SearchFunction = (props) => {
  const stats = useSelector((state) => state.stats);
  const eventType = useSelector((state) => state.stats.eventType);

  const {
    globalFilter,
    searchText,
    company_id,
    event_ID,
    statsByID,
  } = stats;

  const handleReload = () => {
    if (globalFilter === "company") {
      props.dispatch(getEventByCompanyID(company_id));
    } else if (globalFilter === "event") {
      props.dispatch(getEventByKeyStroke(searchText));
      props.dispatch(getStatByID(event_ID));
    }
  };

  return (
    <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }} m={1}>
      <Accordion sx={{ width: "95%", background: "white" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
            }}
            m={2}
          >
            <Typography>Search Filters</Typography>
            {globalFilter === "event" &&
              Object.entries(statsByID).length > 0 ? (
              <>
                <Typography
                  sx={{ display: { xs: "none", md: "block", lg: "block" } }}
                >
                  {`${searchText}` + " "}

                  <span style={{ color: "blue" }}>
                    ( {statsByID.dateFrom} - {statsByID.dateTo} )
                  </span>
                </Typography>
              </>
            ) : (
              ""
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container justifyContent={"space-evenly"} spacing={2} p={0}>
            <SearchByCompanyID />
            <AutoCompleteCompanyAndEvent />

            {globalFilter === "event" && eventType !== "bc" && (
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <DatesInput />
              </Grid>
            )}
          </Grid>

          <Grid container justifyContent={"center"} spacing={2} p={1}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={2}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                onClick={handleReload}
                style={{ background: "#BBB8B2" }}
              >
                Reload
                <ReplayIcon />
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default connect()(SearchFunction);
